/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Page service
 * Service provides page data.
 * OpenAPI spec version: 2.0.0
 */
import { adapter } from './adapter';
/**
 * Valid site response
 */
export type Site = Region | Hotel | Category | Redirect;

export type Agents = typeof Agents[keyof typeof Agents];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Agents = {
  'aidu-de': 'aidu-de',
  'aidu-at': 'aidu-at',
  'aidu-ch': 'aidu-ch',
  'invia-cz': 'invia-cz',
  'invia-sk': 'invia-sk',
  'invia-hu': 'invia-hu',
  'travelplanet-pl': 'travelplanet-pl',
  'reisen-de': 'reisen-de',
  'reisegeier-de': 'reisegeier-de',
  'reisegeier-at': 'reisegeier-at',
  'reisegeier-ch': 'reisegeier-ch',
  'reisen-fluege-de': 'reisen-fluege-de',
} as const;

/**
 * In the case of a redirect response, the front end must send a redirect to the consumer.
 */
export interface Redirect {
  responseType: ResponseType;
  /** Redirect location */
  location: string;
  /** Redirect code */
  code: number;
  /** A more detailed description, why we're redirecting. */
  message: string;
}

/**
 * Contains all the required elements of a page. Other objects extend this.
 */
export interface BaseSite {
  template: TemplateDeviceMapping;
  responseType: ResponseType;
  page: Page;
  parent?: Page;
  meta: MetaDeviceMapping;
  printAndDownload?: PrintAndDownload;
}

export type RegionAllOf = {
  blocks: Blocks;
  spotlight: BlockDeviceMapping;
  top: BlockDeviceMapping;
  content: BlockDeviceMapping;
  sidebar: BlockDeviceMapping;
};

/**
 * region page
 */
export type Region = BaseSite & RegionAllOf;

export type HotelAllOfHotel = { [key: string]: unknown };

export type HotelAllOf = {
  blocks: Blocks;
  spotlight: BlockDeviceMapping;
  top: BlockDeviceMapping;
  content: BlockDeviceMapping;
  sidebar: BlockDeviceMapping;
  hotel: HotelAllOfHotel;
};

/**
 * hotel detail page
 */
export type Hotel = BaseSite & HotelAllOf;

export type CategoryAllOf = {
  blocks: Blocks;
  spotlight: BlockDeviceMapping;
  top: BlockDeviceMapping;
  content: BlockDeviceMapping;
  sidebar: BlockDeviceMapping;
  skyscraper?: BlockAdition;
};

/**
 * category page
 */
export type Category = BaseSite & CategoryAllOf;

/**
 * Defines all available success response types.
 */
export type ResponseType = typeof ResponseType[keyof typeof ResponseType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResponseType = {
  redirect: 'redirect',
  site: 'site',
} as const;

/**
 * the headline with text and html node tag
 */
export interface Headline {
  /** the content of the headline */
  text: string;
  tag: HeadlineTag;
}

/**
 * HTML tag for the headline
 */
export type HeadlineTag = typeof HeadlineTag[keyof typeof HeadlineTag];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HeadlineTag = {
  span: 'span',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
} as const;

/**
 * contains the page template name per device
 */
export interface TemplateDeviceMapping {
  lg: string;
  md: string;
  sm: string;
}

/**
 * contains the page meta data per device
 */
export interface MetaDeviceMapping {
  lg: Meta;
  md: Meta;
  sm: Meta;
}

/**
 * print & download section fo the page
 */
export interface PrintAndDownload {
  printCaption?: string;
  downloadCaption: string;
  downloadFile: string;
  fileName: string;
}

/**
 * contains the page meta data
 */
export interface Meta {
  /**
   * html meta title tag
   * @minLength 1
   */
  title: string;
  /** @minLength 1 */
  description: string;
  /**
   * html meta robots tag
   * @minLength 1
   */
  robots: string;
  links: MetaLink[];
  markups?: MetaMarkup[];
}

/**
 * Defines a meta link element.
 */
export interface MetaLink {
  rel: string;
  hreflang?: string;
  href: string;
}

/**
 * Defines a meta markup element.
 */
export interface MetaMarkup {
  type: string;
  content: string;
}

/**
 * page data.
 */
export interface Page {
  id: string;
  name: string;
  path: string;
  type: PageType;
  keywordType?: KeywordType;
  tree?: string;
  subtree?: string;
  trees?: string[];
  travelTypes?: string[];
}

/**
 * Defines all available keyword types.
 */
export type KeywordType = typeof KeywordType[keyof typeof KeywordType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const KeywordType = {
  continent: 'continent',
  multicountry: 'multicountry',
  country: 'country',
  destination: 'destination',
  city: 'city',
  hotel: 'hotel',
} as const;

/**
 * Defines all available page types.
 */
export type PageType = typeof PageType[keyof typeof PageType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PageType = {
  start: 'start',
  category: 'category',
  landing: 'landing',
  hotelDetail: 'hotelDetail',
} as const;

/**
 * Contains a headline and a list of hotel offers
 */
export interface BlockOffers {
  headline?: Headline;
  items: Offer[];
  offerRequestUrl?: OfferRequestUrl;
  offerParams?: OfferParams;
}

/**
 * offer params
 */
export interface OfferParams {
  /** offer adults */
  adults: number;
}

/**
 * relative urls to request offers from reco service
 */
export interface OfferRequestUrl {
  /** url to request package tour offers */
  packageTour?: string;
  /** url to request own arrival offers */
  ownArrival?: string;
}

/**
 * Hotel data
 */
export interface Offer {
  id: string;
  name: string;
  url: string;
  updated?: string;
  category?: HotelCategory;
  country: string;
  destinations?: string[];
  city: string;
  address?: Address;
  rating?: Rating;
  images?: Image[];
  packageTour?: DefaultHotelOffer;
  ownArrival?: DefaultHotelOffer;
  offerRequestUrl?: OfferRequestUrl;
}

/**
 * Default hotel offer
 */
export interface DefaultHotelOffer {
  /** adults count */
  adults: number;
  /** duration */
  duration: number;
  /** price information */
  catering: string;
  /** room information */
  room: string;
  prices: Price[];
}

/**
 * address data of the hotel (street and city) with (optional) country code
 */
export interface Address {
  /** the city */
  city?: string;
  /** the two-letter (ISO) county code */
  countryCode?: string;
  /** street name without number */
  street?: string;
  /** the number(s) of the house within the street */
  streetNumber?: string;
  /** the zip code */
  zip?: string;
}

/**
 * hotel ratings
 */
export interface Rating {
  /** review count */
  count: number;
  /** review score */
  score: number;
  /** recommendation score */
  recommendation: number;
}

export interface BlockDeviceMapping {
  /** @nullable */
  lg: BlockDeviceMappingItem[] | null;
  /** @nullable */
  md: BlockDeviceMappingItem[] | null;
  /** @nullable */
  sm: BlockDeviceMappingItem[] | null;
}

export interface BlockDeviceMappingItem {
  /** uuid for the corresponding block */
  id: string;
}

export type BlocksItem = {
  /** directus collection name */
  collection: string;
  /** uuid for the corresponding block */
  id: string;
  item?: OneOfBlockItem;
  /** size of requested items */
  size?: number;
  /** total number of items */
  total?: number;
  /** current page of requested items */
  currentPage?: number;
  /** last page of requested items */
  lastPage?: number;
  /** true, if the items are alternatives in case of no hotels found */
  alternatives?: boolean;
};

/**
 * list of content blocks
 */
export type Blocks = BlocksItem[];

/**
 * represent different block items
 */
export type OneOfBlockItem = BlockAdition | BlockText | BlockLayout | BlockLinks | BlockChildren | BlockBreadcrumb | BlockNewsletter | BlockAdvertisement | BlockRss | BlockTopLovedDestinations | BlockActualOffers | BlockSearchResults | BlockLastSearches | BlockSearchform | BlockBillboard | BlockIframe | BlockOffer | BlockOffers | BlockBanner | BlockImages | BlockImagesV2 | BlockVideo | BlockTrustElements | BlockLinkGroup | BlockSeoHotelInfo | BlockDestinationReviews | BlockHotelReviews | BlockExpertReview | BlockHotelTour | BlockFlightOffer | BlockHeroHeadline | BlockBadges | BlockHeroImage | BlockGoogleReviews;

/**
 * directus trust elements block
 */
export interface BlockTrustElements {
  headline?: Headline;
  /** column count for desktop */
  columns: number;
  /** list of trust element items */
  items: BlockTrustElementsItem[];
}

export interface BlockTrustElementsItem {
  image: Image;
  /** markdown text to explain the item */
  keyfact: string;
  /** optional url to to link the box to */
  linkURL?: string;
  /** title attribute for link_url */
  linkTitle?: string;
}

/**
 * directus video block
 */
export interface BlockVideo {
  /** file name in Directus (via id to embed) */
  filename: string;
  /** textual name of the file */
  filenameAlias: string;
  /** content type */
  type: string;
  headline?: Headline;
}

/**
 * directus image / gallery block
 */
export interface BlockImages {
  headline?: Headline;
  /** layout for images (single-centered/stretched, row, ...) */
  layout: string;
  items: BlockImagesItem[];
}

/**
 * Layout type for the block
 */
export type BlockImagesV2Layout = typeof BlockImagesV2Layout[keyof typeof BlockImagesV2Layout];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BlockImagesV2Layout = {
  big_image: 'big_image',
  one_row_center: 'one_row_center',
  one_row_full: 'one_row_full',
  two_row: 'two_row',
  three_row: 'three_row',
} as const;

/**
 * directus block image v2
 */
export interface BlockImagesV2 {
  headline?: Headline;
  /** subline text */
  subline?: string;
  /** Layout type for the block */
  layout: BlockImagesV2Layout;
  image_lg?: Image;
  image_md?: Image;
  image_sm?: Image;
  /** List of row-based images */
  rowImages?: Image[];
}

/**
 * image item on block_images
 */
export interface BlockImagesItem {
  /** alt text */
  alt?: string;
  image: Image;
}

/**
 * directus children block
 */
export interface BlockChildren {
  linkBlocks?: BlockLinks[];
}

/**
 * directus offer block
 */
export interface BlockOffer {
  /** offer block type */
  type: string;
  headline?: Headline;
  /** offer block subHeadline */
  subHeadline?: string;
  offers?: BlockOfferItem[];
  showMoreLink?: Link;
}

/**
 * directus flight offer
 */
export interface BlockFlightOffer {
  headline?: Headline;
  offers?: BlockFlightOfferItem[];
}

/**
 * directus hero headline
 */
export interface BlockHeroHeadline {
  headline?: Headline;
  /** subline text */
  subline?: string;
}

/**
 * directus badges
 */
export interface BlockBadges {
  /** array of badges */
  badges?: Badge[];
}

/**
 * ex. lastMinute, offer, trustElement
 */
export type BadgeType = typeof BadgeType[keyof typeof BadgeType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BadgeType = {
  lastMinute: 'lastMinute',
  offer: 'offer',
  trustElement: 'trustElement',
} as const;

/**
 * badge item of block badges collection
 */
export interface Badge {
  /** ex. lastMinute, offer, trustElement */
  type: BadgeType;
  /** tooltip text */
  tooltipText?: string;
  /** url of the link */
  linkUrl: string;
  /** url of the split link */
  linkUrlSplit?: string;
  /** value */
  value?: number;
  /** rotate right */
  rotateRight?: boolean;
  /** color of the badge */
  badgeColor?: string;
  /** color of the text */
  textColor?: string;
  imageLarge?: Image;
  imageMedium?: Image;
  imageSmall?: Image;
}

/**
 * hero image for background
 */
export interface BlockHeroImage {
  itemImage?: Image;
}

/**
 * directus billboard block
 */
export interface BlockBillboard {
  /** the billboard id */
  id: string;
}

/**
 * directus advertisement block
 */
export interface BlockAdvertisement {
  /** cpcKey for Desktop */
  cpcKeyDesktop?: string;
  /** cpcKey for Mobile */
  cpcKeyMobile?: string;
  /** advertisement block cpcId */
  cpcId?: string;
  /** advertisement block cpcType */
  cpcType?: string;
}

/**
 * directus adition block
 */
export interface BlockAdition {
  /** array of settings for different breakpoints */
  settings: BlockAditionSetting[];
}

/**
 * directus rss feed block
 */
export interface BlockRss {
  headline?: Headline;
  items: Article[];
}

/**
 * directus link group block
 */
export interface BlockLinkGroup {
  headline?: Headline;
  items?: BlockLinks[];
}

/**
 * directus actual offers block
 */
export interface BlockActualOffers { [key: string]: unknown }

/**
 * search results placeholder
 */
export interface BlockSearchResults { [key: string]: unknown }

/**
 * lastSearches placeholder
 */
export interface BlockLastSearches { [key: string]: unknown }

/**
 * directus top loved destinations block
 */
export interface BlockTopLovedDestinations {
  headline?: Headline;
}

/**
 * adition setting for a breakpoint
 */
export interface BlockAditionSetting {
  /** shortcut for the breakpoint */
  breakpoint: string;
  /** adition placement name */
  placementName: string;
  /** adition content unit id */
  contentUnitId: string;
}

/**
 * detailed information about the hotel
 */
export interface BlockHotelTour {
  categories: HotelTourCategories;
}

/**
 * detailed information about the hotel
 */
export type HotelTourCategories = HotelTourCategory[];

/**
 * information category / topic, e.g. rooms or wellness
 */
export interface HotelTourCategory {
  headline?: HotelTourHeadline;
  items?: HotelTourCategoryItem[];
}

export interface HotelTourCategoryItem {
  headline?: HotelTourHeadline;
  description?: string;
  attributes?: HotelTourCategoryItemAttribute[];
}

/**
 * ex. h1, h2, h3
 */
export type HotelTourHeadlineTag = typeof HotelTourHeadlineTag[keyof typeof HotelTourHeadlineTag];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HotelTourHeadlineTag = {
  span: 'span',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
} as const;

export interface HotelTourHeadline {
  /** ex. h1, h2, h3 */
  tag: HotelTourHeadlineTag;
  /** headline text */
  content: string;
}

export type HotelTourCategoryItemAttribute = string;

/**
 * a classic expert review
 */
export interface BlockExpertReview {
  /** the review content */
  content: string;
  headline?: ClassicHotelReviewHeadline;
}

/**
 * classic destination reviews
 */
export interface BlockDestinationReviews {
  headline: string;
  count: number;
  average: number;
  items: DestinationReview[];
}

/**
 * a classic destination review
 */
export interface DestinationReview {
  author: string;
  rating: number;
  comment: string;
}

/**
 * classic hotel reviews
 */
export interface BlockHotelReviews {
  headline: Headline;
  items: ClassicHotelReview[];
}

/**
 * ex. h1, h2, h3
 */
export type ClassicHotelReviewHeadlineTag = typeof ClassicHotelReviewHeadlineTag[keyof typeof ClassicHotelReviewHeadlineTag];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClassicHotelReviewHeadlineTag = {
  span: 'span',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
} as const;

/**
 * use for classic only! do not include hotel names here.
 */
export interface ClassicHotelReviewHeadline {
  /** ex. h1, h2, h3 */
  tag: ClassicHotelReviewHeadlineTag;
  /** headline text */
  content: string;
  /** sub headline text */
  sub?: string;
}

/**
 * classic hotel review
 */
export interface ClassicHotelReview {
  title: string;
  /** date of travel */
  tripDate: string;
  tripType: string;
  tripReason: string;
  author: string;
  hotel: string;
  /**
   * average rating for all review categories
   * @minimum 0
   * @maximum 5
   */
  rating: number;
  recommended: boolean;
  details: ClassicHotelReviewDetail[];
}

/**
 * review details from classic
 */
export interface ClassicHotelReviewDetail {
  category: string;
  /** review text for the category */
  content: string;
}

/**
 * directus text block
 */
export interface BlockText {
  headline?: Headline;
  /** text block markdown */
  text: string;
  /** background color of the text box */
  backgroundColor: string;
  /** show/hide box frame */
  showFrame: boolean;
  /** button orientation */
  buttonAlignment?: string;
  ctaButtons?: CTAButton[];
}

/**
 * block_text button
 */
export interface CTAButton {
  /** button caption */
  caption?: string;
  /** button type */
  type?: string;
  /** button url */
  url?: string;
}

/**
 * directus layout block
 */
export interface BlockLayout {
  headline?: Headline;
  items?: BlockText[];
}

/**
 * directus banner block
 */
export interface BlockBanner {
  /** a label */
  label: string;
  /** the banner type */
  type: string;
}

/**
 * directus seo hotelinfo block
 */
export interface BlockSeoHotelInfo {
  /** what to show */
  hotelInfoType: string;
  headline?: Headline;
  hotel?: Offer;
  gallery?: Gallery;
  attributes?: Attributes;
  reviewSummary?: ReviewSummary;
  reviewDetails?: ReviewDetails;
}

/**
 * overall score and category scores
 */
export interface ReviewSummary {
  score: number;
  reviewPercent: number;
  reviewCount: number;
  categories?: ReviewSummaryCategory[];
}

/**
 * category scores
 */
export interface ReviewDetails {
  categories?: ReviewSummaryCategory[];
}

/**
 * score of a specific category
 */
export interface ReviewSummaryCategory {
  type: string;
  score: number;
}

/**
 * grouped list of hotel attributes
 */
export type Attributes = AttributeGroup[];

/**
 * hotel attribute group
 */
export interface AttributeGroup {
  /** the title / headline / name */
  title?: string;
  items: AttributeItem[];
}

/**
 * one hotel attribute
 */
export interface AttributeItem {
  /** the invia attribute code */
  code: string;
  /** translated name */
  name: string;
  value?: string;
}

/**
 * image gallery
 */
export interface Gallery {
  images: Image[];
}

/**
 * resize solution
 */
export type BlockIframeResizeSolution = typeof BlockIframeResizeSolution[keyof typeof BlockIframeResizeSolution];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BlockIframeResizeSolution = {
  own: 'own',
  partner: 'partner',
} as const;

/**
 * directus iframe block
 */
export interface BlockIframe {
  headline?: Headline;
  /** subline text */
  subHeadline?: string;
  /** iframe target url */
  url: string;
  /** resize solution */
  resizeSolution: BlockIframeResizeSolution;
  /** the title tag */
  iframeTitle: string;
  iframeAttributes?: BlockIframeAttributeRepeaterItem[];
  scriptUrl?: string;
  scriptAttributes?: BlockIframeAttributeRepeaterItem[];
  onMountCall?: string;
  onUnmountCall?: string;
}

/**
 * TODO
 */
export interface BlockIframeAttributeRepeaterItem {
  key?: string;
  value?: string;
}

/**
 * directus searchform block
 */
export interface BlockSearchform {
  /** searchform block type */
  type: string;
  /** form to show on page load */
  defaultForm: string;
  /** number of adults */
  adults: number;
  /** array of children ages */
  children?: number[];
  /** arrival date for search form */
  arrivalDate: string;
  /** return date for search form */
  returnDate: string;
  /** destination id */
  destinationId?: string;
  /** destination name */
  destinationName?: string;
  /** keyword type for tracking purposes */
  keywordType?: string;
  duration: Duration;
  /** array of tour operators */
  tourOperators?: string[];
  destinationField?: DestinationField;
  airportField?: AirportField;
}

export interface AirportsNearbyItem {
  code: string;
  distance: string;
}

/**
 * airport field blocks
 */
export type AirportsNearby = AirportsNearbyItem[];

export interface AirportGroupAirportsItem {
  code: string;
  nearby?: AirportsNearby;
}

/**
 * airport field blocks
 */
export type AirportGroupAirports = AirportGroupAirportsItem[];

export interface AirportGroupItem {
  code: string;
  default?: boolean;
  children?: ChildrenAirportGroup;
  airports?: AirportGroupAirports;
}

/**
 * airport field groups
 */
export type ChildrenAirportGroup = AirportGroupItem[];

/**
 * airport field groups
 */
export type AirportGroup = AirportGroupItem[];

/**
 * airport field blocks
 */
export interface AirportField {
  items?: AirportGroup;
}

/**
 * destination field blocks
 */
export interface DestinationField {
  items?: BlockDeviceMapping;
}

/**
 * newsletter block
 */
export interface BlockNewsletter {
  headline?: Headline;
  /** newsletter block subHeadline */
  subHeadline?: string;
}

export type BlockLinksTravelType = typeof BlockLinksTravelType[keyof typeof BlockLinksTravelType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BlockLinksTravelType = {
  packageTour: 'packageTour',
  ownArrival: 'ownArrival',
} as const;

/**
 * links block type
 */
export type BlockLinksType = typeof BlockLinksType[keyof typeof BlockLinksType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BlockLinksType = {
  text: 'text',
  text_and_icon: 'text_and_icon',
  image: 'image',
  teaser_box: 'teaser_box',
  text_and_small_image: 'text_and_small_image',
} as const;

/**
 * links block
 */
export interface BlockLinks {
  headline?: Headline;
  /** links block subHeadline */
  subHeadline?: string;
  /** use for type=image only! the number of columns to show the link list. */
  columns?: number;
  travelType?: BlockLinksTravelType;
  /** links block type */
  type: BlockLinksType;
  links?: Link[];
}

/**
 * directus breadcrumb block
 */
export interface BlockBreadcrumb {
  /** text block prefix */
  prefix: string;
  links?: Link[];
}

/**
 * link
 */
export interface Link {
  /** link url (href) */
  url?: string;
  /** link target */
  target?: string;
  /** masked link or not */
  masked?: boolean;
  /** link text */
  text: string;
  /** link description */
  description?: string;
  /** hotel count for sidebar links */
  count?: number;
  /** keyword */
  keyword?: string;
  image?: Image;
  /** campaign name for tracking purposes */
  trackingLabel?: string;
}

export interface BlockFlightOfferItem {
  /** The airline code */
  airline?: string;
  /** The name of the airline */
  airlineName?: string;
  /** Arrival location code */
  arr?: string;
  /** Departure location code */
  dep?: string;
  /** Arrival continent */
  arrContinent?: string;
  /** Departure continent */
  depContinent?: string;
  /** Arrival country */
  arrCountry?: string;
  /** Departure country */
  depCountry?: string;
  /** Arrival city */
  arrCity?: string;
  /** Departure city */
  depCity?: string;
  /** Arrival airport code */
  arrAirport?: string;
  /** Departure airport code */
  depAirport?: string;
  /** Departure date */
  depDate?: string;
  /** Return date */
  retDate?: string;
  /** Deeplink to the offer */
  deeplink?: string;
  prices?: Price[];
}

/**
 * directus offer
 */
export interface BlockOfferItem {
  /** number of adults */
  adults?: number;
  category?: DirectusCategory;
  /** travel duration */
  duration?: number;
  prices?: Price[];
  /** IBE url (href) */
  url: string;
  /** ibe url classic (href) */
  urlClassic?: string;
  boardType?: DirectusBoardType;
  roomType?: DirectusRoomType;
  /** label text */
  label: string;
  /** subLabel text */
  subLabel?: string;
  /** price information */
  priceInformation?: string;
  /** badge text */
  badge?: string;
  image?: Image;
  /** destination keyword */
  destinationId?: string;
}

/**
 * directus board type
 */
export interface DirectusBoardType {
  /** directus board code */
  code?: string;
  /** directus board name */
  name?: string;
}

/**
 * directus room type
 */
export interface DirectusRoomType {
  /** directus room code */
  code?: string;
  /** directus room name */
  name?: string;
}

/**
 * directus category
 */
export interface DirectusCategory {
  /** directus category type */
  type?: string;
  /** directus category value */
  value?: number;
}

/**
 * a price object with price value and currency
 */
export interface Price {
  /** price value */
  value: number;
  /** currency of the price */
  currency: string;
}

/**
 * directus image
 */
export interface Image {
  /** image type */
  type: string;
  /** directus image id */
  id?: string;
  /** MIME type/extension of the directus image */
  extension?: string;
  /** external image url */
  url?: string;
  /** alternative text */
  alt?: string;
}

/**
 * duration values min and max
 */
export interface Duration {
  /** min travel duration */
  min: number;
  /** max travel duration */
  max: number;
}

/**
 * hotel category
 */
export interface HotelCategory {
  value: number;
  type: string;
}

/**
 * a wordpress magazine article
 */
export interface Article {
  /** published date of the article */
  date: string;
  /** title of the article */
  title: string;
  /** label of the article */
  label: string;
  /** magazine link of the article */
  link: string;
  /** magazine teaser image of the article */
  image: string;
}

/**
 * A block with several Google reviews.
 */
export interface BlockGoogleReviews {
  headline?: Headline;
  /** The average rating of all reviews. */
  averageRating: number;
  /** The total count of all reviews. */
  totalReviewCount: number;
  /** The actual Google reviews. */
  reviews: ItemGoogleReview[];
}

/**
 * An actual Google review.
 */
export interface ItemGoogleReview {
  /** The name of the reviewer. */
  reviewerName: string;
  /** The details to the reviewer. */
  reviewerDetails?: string;
  /** The URL to the profile photo of the reviewer. */
  reviewerProfilePhotoURL?: string;
  /** The comment of the reviewer. */
  comment: string;
  /** The star rating of the review. */
  starRating: number;
  /** The creation time of the review. */
  reviewCreateTime: string;
}

export type ErrorResponse = {
  /** Error code */
  code: number;
  /** Error message */
  message: string;
};

/**
 * success
 */
export type SiteResponse = Site;

export type SiteParams = {
/**
 * the SEO page path
 */
path: string;
/**
 * agent
 */
agent: Agents;
/**
 * do not provide offers
 */
noOffers?: boolean;
};

export type TreeParams = {
/**
 * invalidate cache
 */
invalidate?: boolean;
/**
 * use SEO tree
 */
seo?: boolean;
};

export type Tree200 = { [key: string]: unknown };

export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

/**
 * Provides SEO page data for category pages and destination landing pages by URL path and portal.
 * @summary Provides SEO page data.
 */
export type siteResponse200 = {
  data: SiteResponse
  status: 200
}

export type siteResponseDefault = {
  data: ErrorResponse
  status: Exclude<HTTPStatusCodes, 200>
}
    
export type siteResponseComposite = siteResponse200 | siteResponseDefault;
    
export type siteResponse = siteResponseComposite & {
  headers: Headers;
}

export const getSiteUrl = (params: SiteParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/site?${stringifiedParams}` : `/site`
}

export const site = async (params: SiteParams, options?: RequestInit): Promise<siteResponse> => {
  
  return adapter<siteResponse>(getSiteUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Provides product and SEO region tree for a given keywordId.
 * @summary Provides region tree.
 */
export type treeResponse200 = {
  data: Tree200
  status: 200
}

export type treeResponseDefault = {
  data: ErrorResponse
  status: Exclude<HTTPStatusCodes, 200>
}
    
export type treeResponseComposite = treeResponse200 | treeResponseDefault;
    
export type treeResponse = treeResponseComposite & {
  headers: Headers;
}

export const getTreeUrl = (keywordId: string,
    params?: TreeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/tree/${keywordId}?${stringifiedParams}` : `/tree/${keywordId}`
}

export const tree = async (keywordId: string,
    params?: TreeParams, options?: RequestInit): Promise<treeResponse> => {
  
  return adapter<treeResponse>(getTreeUrl(keywordId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
